import $http from "../../axios";
import { Notification } from "element-ui";


export async function getWallet({ state, commit }, params) {

    if(params){
        state.params.seller_id = params.seller_id ? params.seller_id : null
        state.params.contact_id = params.contact_id
        state.params.wallet_type = params.wallet_type
    }

    await $http.get("/api/consulta-cartera-tercero", {params: state.params})
        .then(response => {
            commit('setwallet', response.data)
        })
        .catch(error => {
            state.loading.wallet = true
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
    state.loading.wallet = false;
}

export async function fetchWalletType(
    { commit, state },
) {
    await $http
        .get("/api/parametros-por-tabla/100")
        .then(response => {
            commit("setWalletType", response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}

export async function getTransactions({ state, commit }, data) {
  await $http.get("/api/transacciones-cartera/" + data[0], {
      params: data[1]
  })
    .then(response => {
      commit('settransactions_wallet', response.data.data)
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
}

export async function getAllClients({state,commit}) {

    await $http.get('/api/all-contacts',{

    }).then( async response=>{
        await commit('setClients',response.data)
    }).catch();

}

export async function fetchContacts({commit, state}, filter) {

    let params = {
        paginate: true,
        query: filter,
        filter: filter,
        only_active:true,
        perPage:100,
    }

    await $http.get('/api/terceros-lite', {params})
        .then((response) => {
            commit('setClients', response.data.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
            commit('contactError', error.message)
        })
}



// WEBPACK FOOTER //
// ./src/modules/historical-by-document/actions.js